
import { DossierConfigService } from "@/services";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			settings: DossierConfigService.getAutoBarcodeConfig()
		};
	},
	computed: {
		valid():boolean {
			if (this.settings.Enabled && `${this.settings.NextBarcode}`.length > 13) {
				return false;
			}
			return true;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			await DossierConfigService.setAutoBarcode(this.settings);
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
